import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import i18n from '../../../../i18n/i18n';
import { getVendorDetails, clearVendorDetails } from '../../../../redux/Slices/authSlice';

const VendorDetails = () => {
  const { t } = useTranslation('global');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const { vendorDetails, isLoading } = useSelector((s) => s.auth);
  const isRTL = i18n.language === 'ar';

  useEffect(() => {
    if (id) {
      dispatch(getVendorDetails(id));
    }
    return () => {
      dispatch(clearVendorDetails());
    };
  }, [dispatch, id, isRTL]);

  if (isLoading) {
    return (
      <div style={{ padding: '30px', backgroundColor: '#14263b', minHeight: 'calc(100vh - 80px)', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', direction: isRTL ? 'rtl' : 'ltr' }}>
        {t('vendors.view.loading')}
      </div>
    );
  }

  if (!vendorDetails) {
    return (
      <div style={{ padding: '30px', backgroundColor: '#14263b', minHeight: 'calc(100vh - 80px)', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', direction: isRTL ? 'rtl' : 'ltr' }}>
        {t('vendors.view.noData')}
      </div>
    );
  }

  const vendor = vendorDetails.data || vendorDetails;

  return (
    <div style={{ padding: '30px', backgroundColor: '#14263b', minHeight: 'calc(100vh - 80px)', color: 'white', direction: isRTL ? 'rtl' : 'ltr' }}>
      <div style={{ marginBottom: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexDirection: 'row' }}>
        <h1 style={{ fontSize: '24px', fontWeight: 'bold', margin: 0, order: isRTL ? 1 : 1 }}>{t('vendors.view.title')} {vendor.id}</h1>
        <button onClick={() => navigate('/vendors')} style={{ background: '#666', color: 'white', border: 'none', borderRadius: 8, padding: '10px 18px', cursor: 'pointer', order: isRTL ? 2 : 2 }}>{t('vendors.view.back')}</button>
      </div>
      <div style={{ backgroundColor: '#1b3350', border: '1px solid #333', borderRadius: '12px', overflow: 'hidden' }}>
        <div style={{ padding: '20px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
            <div>
              <div style={{ color: '#9ca3af', fontSize: '12px', marginBottom: '4px', direction: isRTL ? 'rtl' : 'ltr', textAlign: isRTL ? 'right' : 'left' }}>{t('vendors.view.id')}</div>
              <div style={{ fontSize: '16px', fontWeight: 'bold', direction: isRTL ? 'rtl' : 'ltr', textAlign: isRTL ? 'right' : 'left' }}>{vendor.id || '-'}</div>
            </div>
            <div>
              <div style={{ color: '#9ca3af', fontSize: '12px', marginBottom: '4px', direction: isRTL ? 'rtl' : 'ltr', textAlign: isRTL ? 'right' : 'left' }}>{t('vendors.view.code')}</div>
              <div style={{ fontSize: '16px', fontWeight: 'bold', direction: isRTL ? 'rtl' : 'ltr', textAlign: isRTL ? 'right' : 'left' }}>
                {typeof vendor.code === 'string' ? vendor.code : (typeof vendor.code === 'object' && vendor.code !== null ? (vendor.code.code || vendor.code.symbol || JSON.stringify(vendor.code)) : (vendor.code || '-'))}
              </div>
            </div>
            <div>
              <div style={{ color: '#9ca3af', fontSize: '12px', marginBottom: '4px', direction: isRTL ? 'rtl' : 'ltr', textAlign: isRTL ? 'right' : 'left' }}>{t('vendors.view.nameEn')}</div>
              <div style={{ fontSize: '16px', fontWeight: 'bold', direction: 'ltr', textAlign: 'left' }}>
                {typeof vendor.name_en === 'string' ? vendor.name_en : (typeof vendor.name === 'string' ? vendor.name : '-')}
              </div>
            </div>
            <div>
              <div style={{ color: '#9ca3af', fontSize: '12px', marginBottom: '4px', direction: isRTL ? 'rtl' : 'ltr', textAlign: isRTL ? 'right' : 'left' }}>{t('vendors.view.nameAr')}</div>
              <div style={{ fontSize: '16px', fontWeight: 'bold', direction: 'rtl', textAlign: 'right', width: '100%', display: 'block' }}>
                {typeof vendor.name_ar === 'string' ? vendor.name_ar : (typeof vendor.name === 'string' ? vendor.name : '-')}
              </div>
            </div>
            <div>
              <div style={{ color: '#9ca3af', fontSize: '12px', marginBottom: '4px', direction: isRTL ? 'rtl' : 'ltr', textAlign: isRTL ? 'right' : 'left' }}>{t('vendors.view.contactPerson')}</div>
              <div style={{ fontSize: '16px', fontWeight: 'bold', direction: isRTL ? 'rtl' : 'ltr', textAlign: isRTL ? 'right' : 'left' }}>
                {typeof vendor.contact_person === 'string' ? vendor.contact_person : '-'}
              </div>
            </div>
            <div>
              <div style={{ color: '#9ca3af', fontSize: '12px', marginBottom: '4px', direction: isRTL ? 'rtl' : 'ltr', textAlign: isRTL ? 'right' : 'left' }}>{t('vendors.view.email')}</div>
              <div style={{ fontSize: '16px', fontWeight: 'bold', direction: 'ltr', textAlign: 'left' }}>
                {typeof vendor.email === 'string' ? vendor.email : '-'}
              </div>
            </div>
            <div>
              <div style={{ color: '#9ca3af', fontSize: '12px', marginBottom: '4px', direction: isRTL ? 'rtl' : 'ltr', textAlign: isRTL ? 'right' : 'left' }}>{t('vendors.view.phone')}</div>
              <div style={{ fontSize: '16px', fontWeight: 'bold', direction: isRTL ? 'rtl' : 'ltr', textAlign: isRTL ? 'right' : 'left' }}>
                {typeof vendor.phone === 'string' ? vendor.phone : '-'}
              </div>
            </div>
            <div>
              <div style={{ color: '#9ca3af', fontSize: '12px', marginBottom: '4px', direction: isRTL ? 'rtl' : 'ltr', textAlign: isRTL ? 'right' : 'left' }}>{t('vendors.view.taxNumber')}</div>
              <div style={{ fontSize: '16px', fontWeight: 'bold', direction: isRTL ? 'rtl' : 'ltr', textAlign: isRTL ? 'right' : 'left' }}>
                {typeof vendor.tax_number === 'string' ? vendor.tax_number : (typeof vendor.tax_number === 'number' ? String(vendor.tax_number) : '-')}
              </div>
            </div>
            <div style={{ gridColumn: '1 / span 2' }}>
              <div style={{ color: '#9ca3af', fontSize: '12px', marginBottom: '4px', direction: isRTL ? 'rtl' : 'ltr', textAlign: isRTL ? 'right' : 'left' }}>{t('vendors.view.address')}</div>
              <div style={{ fontSize: '16px', fontWeight: 'bold', direction: isRTL ? 'rtl' : 'ltr', textAlign: isRTL ? 'right' : 'left' }}>
                {typeof vendor.address === 'string' ? vendor.address : '-'}
              </div>
            </div>
            <div>
              <div style={{ color: '#9ca3af', fontSize: '12px', marginBottom: '4px', direction: isRTL ? 'rtl' : 'ltr', textAlign: isRTL ? 'right' : 'left' }}>{t('vendors.view.status')}</div>
              <span style={{
                backgroundColor: vendor.is_active ? '#AC2000' : '#dc3545',
                color: 'white',
                padding: '6px 14px',
                borderRadius: '20px',
                fontSize: '12px',
                fontWeight: 'bold',
                display: 'inline-block'
              }}>
                {vendor.is_active ? t('vendors.statuses.active') : t('vendors.statuses.inactive')}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VendorDetails;

